import React from 'react';
import './meet-platform.css';
import Monitor1 from '../elements-icons/Monitor1';
import HandBrain1 from '../elements-icons/HandBrain1';
import Documents1 from '../elements-icons/Documents1';
import PlatformCard from '../platform-card/PlatformCard';

const MeetPlatform = () => {
  
  const cardContent = [
    {
      url: '/prompt-library',
      cardClass: 'bg-straight-gradient-purple',
      icon: <Monitor1 svgClass='icon-lg' pathClass='icon-pink' />,
      iconClass: 'icon-card-circle-lg icon-container bg-white',
      title: 'Prompt Library',
      content: 'The library is a thoughtfully curated collection of AI prompts. No matter if you\'re from Sales, HR, or IT, we\'ve got something that\'ll fit right into your workflow.',
    },
    {
      url: '/documentation',
      cardClass: 'bg-transparent',
      icon: <Documents1 svgClass='icon-lg' pathClass='icon-wht' />,
      iconClass: 'icon-card-circle-lg icon-container bg-slanted-gradient-green',
      title: 'Documentation',
      content: 'Sometimes, we all need a little guidance. The documentation isn\'t just a manual—it\'s your companion in understanding how best to use AI prompts, with handy usage guides and an FAQ section for your quick queries.',
    },
    {
      url: '/training',
      cardClass: 'bg-transparent',
      icon: <HandBrain1 svgClass='icon-lg' pathClass='icon-wht' />,
      iconClass: 'icon-card-circle-lg icon-container bg-slanted-gradient-orange',
      title: 'Training/Best Practices',
      content: 'Think of this as a workshop where you can refine your understanding. From design principles to real-world examples, this section is all about helping you craft and use prompts effectively.',
    }
  ]
  
  return (
    <section className='section-meet-platform text-lt'>
      <div className='wrapper-meet-platform center'>
        <div className='content-meet-platform-intro'>
          <h2 className='title-sub-1'>
            Meet The Platform
          </h2>
          <p className='paragraph-lt paragraph-meet-platform'>
            Welcome to Prompt AI University. This platform has been meticulously designed for users like you. It aims to support and guide your journey with AI-assisted business communication.
          </p>
          <p className='paragraph-lt semi-bold'>
            Let's take a quick look at what's inside:
          </p>
        </div>
        <div className='content-meet-platform-cards'>
          {cardContent.map((card, index) =>
            <PlatformCard key={index} card={card} index={index} />
          )}
        </div>
      </div>
    </section>
  );
}

export default MeetPlatform;
